export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error("Error")
    error.response = response
    throw error
  }
}

export function checkInstagramStatus(response) {
  if (response.code === 1 && response.data) {
		var error = new Error("Error")
    error.response = response
    throw error
  } else {
		return response
  }
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js